export default {
  entities: {
    notification: {
      notificationsList: {
        headers: ['Sarlavha', 'Xabarnoma', 'Qabul qilindi'],
      },
    },
  },
};
